import React from 'react';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';
import PropTypes from 'prop-types';

const DeliveryOptionsPanel = ({
  branchName,
  branchUrl,
  deliveryPreferences,
  isDeliveryUnavailable,
  userLocation,
}) => {
  const DELIVERY_OPTIONS_SCHEMA = {
    CLICK_AND_COLLECT: {
      prefix: 'Click & Collect from',
      branch: deliveryPreferences?.branch,
      suffix: '7 DAYS',
      icon: 'title-icon--location-green',
    },
    COLLECT_FROM_BRANCH: {
      prefix: 'Click & Collect from',
      branch: branchName,
      suffix: '48 HOURS',
      icon: 'title-icon--location-green',
    },
    HOME_DELIVERY: {
      prefix: 'Home delivery within 30 miles of',
      icon: 'title-icon--home-green',
      branch: branchName,
    },
    NONE: {
      prefix: 'Located at',
      branch: branchName,
      icon: '',
    },
  };

  const openDeliveryOptionsModal = () =>
    EventEmitter.emit(EVENT_TYPES.openModal, 'delivery-options-modal');

  const clickAndCollectOption = () => {
    return (
      <div className="ch-mb--0 ch-pa--2 md:ch-bb--0 ch-bc--grey-3 ch-display--flex ch-align-items--center ch-bb--1">
        <div
          className={`title-icon ${
            DELIVERY_OPTIONS_SCHEMA[deliveryPreferences.preference]?.icon
          } ch-flex--none ch-mr--2`}
        />
        <div className="ch-flex-flow--column-wrap delivery-options__title">
          <p className="ch-ma--0">
            {DELIVERY_OPTIONS_SCHEMA[deliveryPreferences.preference]?.prefix}
            <span className="ch-mb--0 ch-fw--500">
              &nbsp;
              {DELIVERY_OPTIONS_SCHEMA[deliveryPreferences.preference]?.branch}
            </span>
          </p>
          {deliveryPreferences.distance_to_customer && (
            <div className="ch-display--flex ch-align-items--center">
              <p className="delivery-options__distance ch-mb--0 ch-pr--1">
                {deliveryPreferences.distance_to_customer} miles away
              </p>
              <p className="delivery-options__chip ch-display--flex ch-lh--base ch-rounded--sm ch-fw--500 ch-mb--0 ch-ph--1">
                COLLECT IN&nbsp;
                <b>
                  {
                    DELIVERY_OPTIONS_SCHEMA[deliveryPreferences.preference]
                      ?.suffix
                  }
                </b>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  };

  const clickAndCollectButton = () => {
    return (
      <button
        className="ch-btn ch-btn--link ch-mh--auto ch-display--flex ch-flex-flow--row-wrap ch-fs--2"
        onClick={() => openDeliveryOptionsModal()}
        type="button"
      >
        {userLocation ? (
          <>
            See delivery options for&nbsp;
            <span className="ch-fw--500">{userLocation}</span>
          </>
        ) : (
          'See your delivery options'
        )}
      </button>
    );
  };

  const renderDeliveryOptions = () => {
    return (
      <div className="ch-ba--1 ch-bc--grey-3 ch-bg--white md:ch-mt--2 ch-rounded--sm ch-fs--2 ch-mb--2 md:ch-mt--2 md:ch-display--flex md:ch-justify-content--between md:ch-align-items--center">
        {clickAndCollectOption()}
        <div className="md:ch-pa--1 ch-flex--none ch-pa--2 ch-bg--white">
          {clickAndCollectButton()}
        </div>
      </div>
    );
  };

  const renderDeliveryUnavailable = () => {
    return (
      <div className="ch-ba--1 ch-bc--grey-3 ch-bg--white md:ch-mt--2 ch-bc--grey-3 ch-rounded--sm ch-fs--2 ch-mb--2 ch-pa--2 ch-display--flex ch-align-items--center">
        <div className="title-icon" />
        <div className="delivery-options__title ch-pl--1">
          <a className="ch-fw--500" href={branchUrl}>
            {branchName}
          </a>
        </div>
      </div>
    );
  };

  return isDeliveryUnavailable
    ? renderDeliveryUnavailable()
    : renderDeliveryOptions();
};

DeliveryOptionsPanel.propTypes = {
  branchName: PropTypes.string,
  branchUrl: PropTypes.string,
  deliveryPreferences: PropTypes.object,
  isDeliveryUnavailable: PropTypes.bool,
  userLocation: PropTypes.string,
};

export default DeliveryOptionsPanel;
